import $ from 'jquery';
import { getRandomAvatar } from './tips';
// 评论滚动
let commentTimer = null;
let hasMini = window.platform.isPhone();
const selfAvatarClass = getRandomAvatar();
export const startLoadingComment = () => {
  if (commentTimer) {
    return;
  }
  commentTimer = setInterval(() => {
    let first = $('.j-chat-wrap div').get(0);
    let height = $(first).outerHeight(true);
    $(first).animate(
      {
        marginTop: -height + 'px',
      },
      1500,
      () => {
        $(first).css('marginTop', 0);
        $(first).hasClass('me')
          ? $(first).remove()
          : $('.j-chat-wrap').append(first);
      }
    );
    // 移动端
    if (hasMini) {
      let miniFirst = $('.j-mini-chat-wrap div').get(0);
      let miniHeight = $(miniFirst).outerHeight(true);
      $(miniFirst).animate(
        {
          marginTop: -miniHeight + 'px',
        },
        1500,
        () => {
          $(miniFirst).css('marginTop', 0);
          $('.j-mini-chat-wrap').append(miniFirst);
        }
      );
    }
  }, 1500);
};
export const stopLoadingComment = () => (commentTimer = null);
const sendMsg = () => {
  const inputVal = $('.j-chat-input').val();
  if (inputVal.length) {
    $(
      `<div class="chat-item me"><i class="avatar ${selfAvatarClass}"></i><p class="chat-text">${inputVal}</p></div>`
    ).insertAfter('.chat-item:nth-child(11)');
    $('.j-chat-input').val('');
  }
};

// 发送按钮 + enter绑定
$('.j-send-btn').on('click', sendMsg);
$('.j-chat-input').on('keypress', event => {
  if (event.keyCode == '13') {
    sendMsg();
  }
});
